import Navbar from "../../../Navbar";
import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Box,
  Button,
  Container,
  DialogActions,
  DialogContentText,
  Grid,
  Stack,
  InputAdornment,
  InputLabel,
  Select,
  FormControl,
  DialogTitle,
  TextField,
  Tooltip,
  MenuItem,
  IconButton,
  Typography,
} from "@mui/material";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //idioma
import { createTheme, ThemeProvider, useTheme } from "@mui/material";

// ICONOS
import AddBoxIcon from "@mui/icons-material/AddBox";
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";

// DIALOG
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

//Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CompuestosPropelentes() {
  const [openSnack, setOpenSnack] = React.useState(false);
  const [compuestos, setCompuestos] = useState();
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [tabla, setTabla] = useState(true);
  const [update, setUpdate] = useState(false);

  const [datosFormulario, setDatosFormulario] = useState({});

  const ObtenerCompuestos = () => {
    //trae la ruta de la api, trae la consulta a traves de res, quest
    //la consulta la guarda en json y el datos del json en un estado
    fetch(UrlApi + "/propelente_compuestos_ef")
      .then((data) => data.json())
      .then((data) => setCompuestos(data));

    //use effect escucha para ejecutar la funcion, va a pasar lo que este dentro de use effect en este caso la funcion
  };

  useEffect(() => {
    ObtenerCompuestos();
  }, [tabla]);

  // FUNCION QUE SE EJECUTA CADA VEZ QUE HAY UN CAMBIO EN LA BASE DE DATOS
  // SIRVE PARA QUE LA TABLA MOSTRADA SE ACTUALICE EN TIEMPO REAL
  useEffect(() => {
    if (update) ObtenerCompuestos();
  }, [update]);

  // PERSONAL: OPERADORES CROMATOGRAFICOS
  const [metodos, setMetodos] = useState();

  const obtenerMetodos = () => {
    fetch(UrlApi + "/metodos/activos") //fetch con la urp de api q esta en services/apirest + la ruta
      .then((data) => data.json()) //mando los datos que recibo en json
      .then((data) => setMetodos(data));
  };

  useEffect(() => {
    obtenerMetodos();
  }, [tabla]);

  //*********************************************************************************************/

  // DIALOG PARA CREAR LOS DATOS
  const [openCrear, setOpenCrear] = React.useState(false);

  const handleClickOpenCrear = () => {
    setOpenCrear(true);
    // AL ABRIR EL DIALOG LOS TEXTFIELDS SE VACIAN
    datosFormulario.nombre_compuesto = "";
    datosFormulario.id_metodo = "";
  };

  const handleCloseCrear = () => {
    setOpenCrear(false);
  };

  //*********************************************************************************************/

  // DIALOG PARA EDITAR LOS DATOS
  const [openEditar, setOpenEditar] = React.useState(false);

  // USANDO ROW TOMO LOS DATOS DE ESA FILA
  const handleClickOpenEditar = (row) => {
    setOpenEditar(true);
    setDatosFormulario(row);
  };

  const handleCloseEditar = (row) => {
    setOpenEditar(false);
    setDatosFormulario(row);
  };

  //**********************************************************************************************/

  // DIALOG PARA ACTIVAR/DESACTIVAR LA RELACIÓN
  const [openDialogOnOff, setOpenDialogOnOff] = React.useState(false);

  const handleCloseDialogOnOff = () => {
    setOpenDialogOnOff(!openDialogOnOff);
  };

  const dialogActivar = (row) => {
    setDatosFormulario(row);
    setOpenDialogOnOff(true);
    setTabla(true);
  };

  //**********************************************************************************************/
  // FUNCIONES PARA GUARDAR:
  // ACTIVAR RELACION
  const guardarActivo = async (e) => {
    console.log("Estoy por guardar");
    e.preventDefault();
    await fetch(
      UrlApi + "/propelente_compuestos_ef/" + datosFormulario.id_compuesto,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 1,
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El compuesto se guardó exitosamente!");
          setUpdate(true);
          //console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el compuesto");
          //console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // DESACTIVAR RELACION
  const guardarInactivo = async (e) => {
    console.log("Estoy por guardar");
    e.preventDefault();
    await fetch(
      UrlApi + "/propelente_compuestos_ef/" + datosFormulario.id_compuesto,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 2,
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El compuesto se guardó exitosamente!");
          setUpdate(true);
          //console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el compuesto");
          //console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  //*************************************************************************************************************************************/

  const columns = [
    {
      header: "ID",
      accessorKey: "id_compuesto",
      minSize: 50,
      size: 80,
      maxSize: 100,
    },
    {
      header: "Compuesto",
      accessorKey: "nombre_compuesto",
    },
    {
      header: "Metodo",
      accessorKey: "nombre_metodo",
    },
    {
      header: "Estado",
      accessorKey: "valor",
    },
  ];

  //*********************************************************************************************/

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setUpdate(false);
    setOpenEditar(false);
    setOpenCrear(false);
    setOpenDialogOnOff(false);
  };

  //*********************************************************************************************/

  //Funcion para guardar AL CREAR
  const guardarCrear = async (e) => {
    console.log("Estoy por guardar");
    e.preventDefault();
    await fetch(UrlApi + "/propelente_compuestos_ef", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nombre_compuesto: datosFormulario.nombre_compuesto,
        id_metodo: datosFormulario.id_metodo,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          setUpdate(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El compuesto se guardó exitosamente !");
          //console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el compuesto");
          //console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  console.log(datosFormulario);

  //Funcion para guardar AL EDITAR
  const guardarEditar = async (e) => {
    console.log("Estoy por guardar");
    e.preventDefault();
    await fetch(
      UrlApi + "/propelente_compuestos_ef/" + datosFormulario.id_compuesto,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nombre_compuesto: datosFormulario.nombre_compuesto,
          id_metodo: datosFormulario.id_metodo,
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          setUpdate(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El compuesto se guardó exitosamente!");
          // console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el compuesto");
          // console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
    //console.log(datosFormulario);
  };

  //*********************************************************************************************/

  const almacenar = (e) => {
    setDatosFormulario({
      ...datosFormulario,
      [e.target.name]: e.target.value,
    });
  };

  // ESTILO PARA LA TABLA

  const globalTheme = useTheme();

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //random light yellow color for the background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1.2rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "1.1rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  return (
    <>
      <Navbar />
      <br />
      {compuestos && tabla ? (
        <Container maxWidth="xl">
          <ThemeProvider theme={tableTheme}>
            <MaterialReactTable
              columns={columns}
              data={compuestos}
              initialState={{
                showGlobalFilter: true,
                density: "compact",
              }}
              localization={MRT_Localization_ES} //idioma ES
              // COLORES PARA LAS CELDAS SEGUN ACTIVO/INACTIVO
              muiTableBodyCellProps={({ row }) => ({
                sx: {
                  backgroundColor:
                    row.original.estado === 1 ? "#66FF66" : "#FF5050",
                  color: "black",
                  borderColor: "black",
                  //COLOR AL PASAR EL MOUSE POR ENCIMA
                  "&:hover": {
                    backgroundColor:
                      row.original.estado === 1 ? "#3ad63a" : "#f22929",
                  },
                  "& .MuiTableCell-root:first-child": {
                    border: "none",
                  },
                },
              })}
              renderTopToolbarCustomActions={({ table }) => (
                <Grid item mt={-2.5}>
                  <h2>COMPUESTOS PARA PROPELENTES</h2>
                </Grid>
              )}
              // ACCIONES
              renderToolbarInternalActions={({ table }) => (
                <>
                  <Tooltip arrow placement="bottom" title="Agregar Compuesto">
                    <IconButton color="primary">
                      <AddBoxIcon
                        onClick={() => {
                          handleClickOpenCrear();
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  <MRT_FullScreenToggleButton table={table} />
                </>
              )}
              enableRowActions
              renderRowActions={({ row }) => (
                <>
                  <Tooltip arrow placement="left" title="Editar Compuesto">
                    <IconButton
                      onClick={() => handleClickOpenEditar(row.original)}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip
                    arrow
                    placement="left"
                    title={
                      row.original.estado === 1
                        ? "Anular Compuesto"
                        : "Activar Compuesto"
                    }
                  >
                    <IconButton onClick={() => dialogActivar(row.original)}>
                      <BlockIcon
                        sx={{
                          color:
                            row.original.estado === 1 ? "red" : "lightgreen",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </>
              )}
              positionActionsColumn="last"
              // TRUE
              enableTopToolbar={true}
              // FALSE
              enableColumnFilters={false} //opcion de filtrado por columnas
              enableDensityToggle={false} //para que no se vea pero esta activo en el estado
              enableHiding={false} //oculta la propiedad show hide columns
            />
          </ThemeProvider>
        </Container>
      ) : null}

      {/* AGREGAR COMPUESTO */}
      <Dialog
        open={openCrear}
        onClose={handleCloseCrear}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <Box
          style={{
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: "#1976D2",
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {"Agregar Compuesto"}
          </DialogTitle>
          <DialogContent>
            <Container maxWidth="xl">
              <form onSubmit={guardarCrear}>
                <Grid container>
                  <Grid item xs={12} mt={2} mb={2}>
                    <TextField
                      name="nombre_compuesto"
                      label="Nombre"
                      placeholder="-"
                      value={datosFormulario.nombre_compuesto}
                      onChange={almacenar}
                      fullWidth
                      focused
                      required
                    />
                  </Grid>
                  <Grid item xs={12} mb={4} mt={1}>
                    <FormControl focused fullWidth>
                      <InputLabel>Metodo</InputLabel>
                      <Select
                        name="id_metodo"
                        label="Metodo"
                        placeholder="-"
                        value={datosFormulario.id_metodo}
                        onChange={almacenar}
                        fullWidth
                        focused
                        required
                      >
                        {metodos
                          ? metodos.map((elemento) => (
                              <MenuItem
                                key={elemento.id_metodo}
                                value={elemento.id_metodo}
                              >
                                {elemento.nombre_metodo}
                              </MenuItem>
                            ))
                          : null}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                />
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCloseCrear}
                  >
                    Cancelar
                  </Button>
                  <Button variant="contained" color="success" type="submit">
                    Guardar
                  </Button>
                </Stack>
                <Stack spacing={2} sx={{ width: "100%" }}>
                  <Snackbar
                    open={openSnack}
                    autoHideDuration={1500}
                    onClose={handleCloseSnack}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  >
                    <Alert
                      onClose={handleCloseSnack}
                      severity="success"
                      sx={{ width: "100%" }}
                      style={{ backgroundColor: colormensaje, color: "black" }}
                    >
                      {mensaje}
                    </Alert>
                  </Snackbar>
                </Stack>
              </form>
            </Container>
          </DialogContent>
        </Box>
      </Dialog>

      {/* EDITAR COMPUESTO */}
      <Dialog
        open={openEditar}
        onClose={handleCloseEditar}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <Box
          style={{
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: "#1976D2",
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {"Editar Compuesto"}
          </DialogTitle>
          <DialogContent>
            <Container maxWidth="xl">
              <form onSubmit={guardarEditar}>
                <Grid container>
                  <Grid item xs={12} mt={2} mb={2}>
                    <TextField
                      name="nombre_compuesto"
                      label="Nombre"
                      InputLabelProps={{ shrink: true }}
                      value={datosFormulario.nombre_compuesto}
                      onChange={almacenar}
                      fullWidth
                      focused
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EditIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} mb={4} mt={1}>
                    <FormControl focused fullWidth>
                      <InputLabel>Metodo</InputLabel>
                      <Select
                        name="id_metodo"
                        label="Metodo"
                        placeholder="-"
                        value={datosFormulario.id_metodo}
                        onChange={almacenar}
                        fullWidth
                        focused
                        required
                      >
                        {metodos
                          ? metodos.map((elemento) => (
                              <MenuItem
                                key={elemento.id_metodo}
                                value={elemento.id_metodo}
                              >
                                {elemento.nombre_metodo}
                              </MenuItem>
                            ))
                          : null}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                />
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCloseEditar}
                  >
                    Cancelar
                  </Button>
                  <Button variant="contained" color="primary" type="submit">
                    Guardar
                  </Button>
                </Stack>
                <Stack spacing={2} sx={{ width: "100%" }}>
                  <Snackbar
                    open={openSnack}
                    autoHideDuration={1500}
                    onClose={handleCloseSnack}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  >
                    <Alert
                      onClose={handleCloseSnack}
                      severity="success"
                      sx={{ width: "100%" }}
                      style={{ backgroundColor: colormensaje, color: "black" }}
                    >
                      {mensaje}
                    </Alert>
                  </Snackbar>
                </Stack>
              </form>
            </Container>
          </DialogContent>
        </Box>
      </Dialog>

      {/* DIALOG PARA BLOQUEAR/DESBLOQUEAR LA RELACION */}
      <Dialog open={openDialogOnOff} onClose={handleCloseDialogOnOff}>
        <Box
          style={{
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: datosFormulario.estado === 1 ? "#e32712" : "#24ff1c",
            color: datosFormulario.estado === 1 ? "red" : "green",
          }}
        >
          <DialogTitle>
            <Typography align="center">
              <b>
                SE {datosFormulario.estado === 1 ? "DESACTIVARÁ" : "ACTIVARÁ"}{" "}
                EL COMPUESTO:
              </b>
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"center"}>
              <Grid item mb={4}>
                <br />
                <b>{datosFormulario.nombre_compuesto}</b>
              </Grid>
            </DialogContentText>
            <DialogContentText textAlign={"center"}>
              {" "}
              {"¿Confirma que quiere " +
                (datosFormulario.estado === 1 ? "desactivar" : "activar") +
                " este compuesto?"}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack spacing={4} direction="row">
              <Grid
                container
                spacing={0}
                alignItems="center"
                justifyContent="center"
              >
                <Grid item mr={22}>
                  <Button
                    style={{
                      backgroundColor: "#d32f2f",
                      color: "#ffffff",
                    }}
                    variant="contained"
                    onClick={handleCloseDialogOnOff}
                  >
                    Cancelar
                  </Button>
                </Grid>{" "}
                {datosFormulario.estado === 1 ? (
                  <Button
                    style={{ backgroundColor: "#fc7a23", color: "#ffffff" }}
                    onClick={guardarInactivo}
                    variant="contained"
                  >
                    Desactivar
                  </Button>
                ) : (
                  <Button
                    style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                    onClick={guardarActivo}
                    variant="contained"
                  >
                    Activar
                  </Button>
                )}{" "}
              </Grid>
            </Stack>
          </DialogActions>
        </Box>
      </Dialog>

      {/* SNACKBAR QUE SE MOSTRARA AL GUARDAR LOS CAMBIOS */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default CompuestosPropelentes;
